import React from 'react';
import { classes } from './Footnote.classes';
import Divider from '../../../Divider';
import { useBaseModalLayoutContext } from '../../BaseModalLayoutContext';
import { FootnoteProps } from './Footnote.types';

export const Footnote = ({
  dataHook,
  className,
  children,
  skin = 'neutral',
}: FootnoteProps) => {
  const { footnoteClassName, footnote = children } =
    useBaseModalLayoutContext();

  return (
    (footnote && (
      <div
        data-hook={dataHook}
        className={classes.root({ skin }, footnoteClassName, className)}
      >
        <Divider className={classes.divider()} />
        <div className={classes.innerContent()}>{footnote}</div>
      </div>
    )) ||
    null
  );
};

Footnote.displayName = 'BaseModalLayout.Footnote';
